// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { SlTpPriceType } from '@shared/utils/Enums/Constants';
import { OperationType } from '@shared/utils/Trading/OperationType';
import { OrderType } from '@shared/utils/Trading/OrderType';
import { OrderUtils } from '@shared/utils/Trading/OrderUtils';
import { Quantity } from '@shared/commons/UtilsClasses/Quantity';
import { Resources } from '@shared/localizations/Resources';
import { SavedOrder } from '../../../SavedOrders/SavedOrder';
import { LinkedPriceType } from '../../../SavedOrders/SavedOrderEnums';
export class PaperPosition extends SavedOrder {
    constructor() {
        super(...arguments);
        this._position = undefined;
        this.Analyse = false;
    }
    get PaperPositionType() {
        return !isNullOrUndefined(this._position)
            ? Resources.getResource('panel.optionPaperPositions.Position')
            : Resources.getResource('panel.optionPaperPositions.PaperPosition');
    }
    get CurrentClosePrice() {
        return !isNullOrUndefined(this._position) && this._position.lastPriceUpdated
            ? this._position.CurPriceClose
            : NaN;
    }
    get Fee() {
        return !isNullOrUndefined(this._position) ? this._position.GetCommissionFromSettlement(true) : 0;
    }
    get OperationStr() {
        return this.isPosition()
            ? Resources.getResource(`general.trading.position.${OrderUtils.getBuySellStr(this.Operation)}`)
            : super.OperationStr;
    }
    get OrderTypeStr() {
        return !isNullOrUndefined(this._position) ? '' : super.OrderTypeStr;
    }
    get TifStr() {
        return !isNullOrUndefined(this._position) ? '' : super.TifStr;
    }
    get QuantityAmount() {
        return Quantity.convertLotsToAmount(this.QuantityLots, this.Instrument, false);
    }
    get PriceForGreeksCalculation() {
        if (this.isPosition()) {
            return this._position.CurPriceClose;
        }
        else if (this.OrderType === OrderType.Market) {
            return this.Instrument.GetMarketPrice(this.Account, this.Operation);
        }
        else if (this.OrderType === OrderType.Stop) {
            return this.StopPrice;
        }
        else {
            return this.GetRealPrice;
        }
    }
    get PriceForPnlCalculation() {
        if (this.OrderType === OrderType.Market) {
            return this.Instrument.GetMarketPrice(this.Account, this.Operation);
        }
        else if (this.OrderType === OrderType.Stop) {
            return this.StopPrice;
        }
        else {
            return this.GetRealPrice;
        }
    }
    get GetRealPrice() {
        if (this.OrderType === OrderType.TrailingStop) {
            const currentPrice = this.Operation === OperationType.Buy
                ? this.Instrument.Level1.GetAsk(this.Account)
                : this.Instrument.Level1.GetBid(this.Account);
            if (currentPrice <= 0) {
                return 0;
            }
            const ticks = (this.Operation === OperationType.Buy ? 1 : -1) * this.StopPrice;
            const ins = this.Instrument;
            return ins.calculatePrice(currentPrice, ticks);
        }
        return this.Price;
    }
    attachPosition(position) {
        this._position = position;
        this.Price = NaN;
        this.StopPrice = NaN;
        this.LinkedPriceOffset = 0;
        this.LinkedPriceType = LinkedPriceType.None;
        this.Active = false;
        this.updatePosition();
    }
    isAttachedPosition(position) {
        return this._position === position;
    }
    isPosition() {
        return !isNullOrUndefined(this._position);
    }
    isSubPosition() {
        return !isNullOrUndefined(this._position) && this._position.isTradePosition;
    }
    updatePosition() {
        const position = this._position;
        if (isNullOrUndefined(position)) {
            return;
        }
        this.Operation = position.BuySell;
        this.QuantityLots = position.Amount;
        this.TIF = position.TimeInForce;
        this.OrderType = position.OrderType;
        this.ProductType = position.ProductType;
        this.Leverage = position.Leverage;
        this.Price = position.Price;
        this.IsAllowOTHTrading = null;
        const slOrder = position.SLOrder;
        if (!isNullOrUndefined(slOrder)) {
            this.SLTPHolder.StopLossPriceType =
                slOrder.OrderType === OrderType.TrailingStop ? SlTpPriceType.TrOffset : SlTpPriceType.Absolute;
            this.SLTPHolder.StopLossPriceValue =
                slOrder.OrderType === OrderType.TrailingStop ? slOrder.TrStopOffset : slOrder.Price;
        }
        else {
            this.SLTPHolder.StopLossPriceValue = NaN;
        }
        const tpOrder = position.TPOrder;
        if (!isNullOrUndefined(tpOrder)) {
            this.SLTPHolder.TakeProfitPriceType = SlTpPriceType.Absolute;
            this.SLTPHolder.TakeProfitPriceValue = tpOrder.Price;
        }
        else {
            this.SLTPHolder.TakeProfitPriceValue = NaN;
        }
    }
}
